import React, { Component } from "react";
import _ from "lodash";
import LocaleStrings from "Languages";
import { connect } from "react-redux";
import { BASE_IMAGES_URL, ACCESS_FILES_API_KEY } from "Constants";

class TableContentMostsearchSession extends Component {
  // Create table body
  renderSessionMostsearchTablelist() {
    // var items=_.map( this.props.websitePages.resource, values => <TablebodyItem key={values.id} values={values}/>);
    var items = _.map(this.props.sessionMostsearkeysTablelist, (values) => {
      return (
        <tr key={values.searchtext}>
          <td>
            <div style={{ marginLeft: "5px" }}>
              {values.searchtext.length > 80
                ? values.searchtext.substring(0, 80) + "..."
                : values.searchtext}
            </div>
          </td>
          <td className="text-center">
            <div> {values.nooftimesearch}</div>
          </td>
          <td className="text-center">
            <div> {values.hit}</div>
          </td>
        </tr>
      );
    });

    return items;
  }

  // Printing the output

  render() {
    return (
      <div className="social-content">
        <div className="tableHeaderSection">
          <p className="analytics-chart-header">
            {LocaleStrings.analytics_sessions_table_header_text1}
          </p>
          <p className="analytics-chart-header">
            {LocaleStrings.analytics_sessions_table_subheader_text1}
          </p>
        </div>
        <table className="table">
          <thead className="analyticsTable">
            <tr>
              <th>{LocaleStrings.analytics_sessions_table_thead_text1}</th>
              <th className="text-center">
                {LocaleStrings.analytics_sessions_table_thead_text2}
              </th>
              <th className="text-center">
                {LocaleStrings.analytics_sessions_table_thead_text3}
              </th>
            </tr>
          </thead>
          <tbody className="tbody-background">
            {this.renderSessionMostsearchTablelist()}
          </tbody>
        </table>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    sessionMostsearkeysTablelist: state.sessionMostsearkeysTablelist,
  };
}

export default connect(mapStateToProps)(TableContentMostsearchSession);
